import React from 'react';

import './group-management.scss';

/** Título do modal com o nome do grupo logo abaixo, como descrição. */
const GroupModalTitle = ({ title, groupName }) => (
    <div className="group-modal-title">
        <span>{title}</span>
        {groupName && <small>{groupName}</small>}
    </div>
);

export default GroupModalTitle;
